import $axios from '@/axios';
import { COMEINURL } from '@/fetch/host';

/**
 * 获取stsToken
 * @param {*} params
 * @param {*} options { fileType, companyId: orgId, specifiedDir, sessionId: newSessionId },
 * @param options.fileType
 * @param options.companyId
 * @param options.specifiedDir
 * @param options.sessionId
 * @returns
 */
export const getStsToken = (params, options = {}) => {
	return $axios.post(`${COMEINURL}/platform/json/upload/ststoken`, params, options);
};

/**
 * 名片识别
 * @param {*} params
 * @param {*} options
 * @param options.viewUrl
 * @returns
 */
export const OcrBusinessCard = (params, options = {}) => {
	return $axios.post(`${COMEINURL}/platform/api/ocr/business-card`, params, options);
};
